import { Link } from "react-router-dom";

const footerLinks = {
  content: [
    { label: "电影", href: "/category/dianying" },
    { label: "电视剧", href: "/category/dianshiju" },
    { label: "综艺", href: "/category/zongyi" },
    { label: "动漫", href: "/category/dongman" },
    { label: "纪录片", href: "/category/jilupian" },
    { label: "音乐", href: "/category/yinyue" },
    { label: "游戏", href: "/category/youxi" },
    { label: "体育", href: "/category/tiyu" },
    { label: "教育", href: "/category/jiaoyu" },
  ],
  about: [
    { label: "关于九色视频", href: "/about" },
    { label: "品牌介绍", href: "/about#intro" },
    { label: "用户口碑", href: "/about#reputation" },
    { label: "联系我们", href: "/about#contact" },
  ],
  help: [
    { label: "常见问题", href: "/about#faq" },
    { label: "使用帮助", href: "/about#contact" },
    { label: "版权声明", href: "/about#contact" },
    { label: "隐私政策", href: "/about#contact" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="text-xl font-bold font-heading">九色视频</span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              九色视频是您最值得信赖的视频内容平台，汇聚海量高清视频资源，涵盖多元内容分类，极速播放体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">内容分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.content.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">关于我们</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">帮助支持</h4>
            <ul className="space-y-2.5">
              {footerLinks.help.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 九色视频 JiuSeShipin. 保留所有权利。
          </p>
          <p className="text-xs text-foreground-500">
            海量高清视频资源一站式平台 | 极速播放 | 畅享精彩
          </p>
        </div>
      </div>
    </footer>
  );
}